import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export function ScrollToTopButton() {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      const scrolled = (scrollTop / docHeight) * 100;
      setProgress(scrolled);
      setVisible(scrollTop > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      onClick={() =>
        window.scrollTo({ top: 0, behavior: "smooth" })
      }
      className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full 
                 bg-white shadow-lg flex items-center justify-center"
      style={{
        background: `conic-gradient(#2563eb ${progress}%, #e5e7eb ${progress}%)`,
      }}
    >
      <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center">
        <ArrowUp className="w-5 h-5 text-blue-600" />
      </div>
    </button>
  );
}
